





import {Component, Prop, Vue} from 'vue-property-decorator';
import JdsMoney from "@/design-system/components/Money/JdsMoney.vue"

/**
 * @status stable
 * @published 4.0.0
 * @changelog 4.0.0 Published.
 *
 * @deprecated Use regular cells with Money.
 */
@Component({
    components: {JdsMoney}
})
export default class JdsTableCurrencyFooter extends Vue {
    @Prop({default: 1}) colspan!: number;
    @Prop({default: 0}) amount!: number;
    @Prop() currency!: string;
}
